import { AuthStateChange, FirebaseAuthentication } from "@capacitor-firebase/authentication";
import { Capacitor } from "@capacitor/core";
import { initializeApp } from "firebase/app";
import {
  Auth,
  GoogleAuthProvider,
  User,
  getAuth,
  indexedDBLocalPersistence,
  initializeAuth,
  onAuthStateChanged,
  signInWithCredential
} from "firebase/auth";

export type FirebaseUser = {
  uid: string;
  displayName?: string | null;
  email?: string | null;
  tenantId?: string | null;
  emailVerified: boolean;
  isAnonymous: boolean;
  phoneNumber?: string | null;
};

class FirebaseService {
  private _auth: Auth;
  constructor() {
    const firebaseConfig = {
      apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyC0siHZqs9-7gkGgrnjM2y_ALYKbHZBhVw",
      authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "garther-develop.firebaseapp.com",
      projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "garther-develop",
      storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "garther-develop.firebasestorage.app",
      messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "519747682916",
      appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:519747682916:web:584d24087e954607099571",
      measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-YVKG5GG4NW"
    };
    const app = initializeApp(firebaseConfig);
    let auth: Auth;
    if (Capacitor.isNativePlatform()) {
      auth = initializeAuth(app, { persistence: indexedDBLocalPersistence });
    } else {
      auth = getAuth(app);
    }

    this._auth = auth;
  }

  get currentUser(): User | null {
    return this._auth.currentUser;
  }

  async onAuthStateChanged(callback: (user: FirebaseUser | null) => void) {
    if (Capacitor.isNativePlatform()) {
      await FirebaseAuthentication.addListener("authStateChange", (s: AuthStateChange) => callback(s.user));
      const currentUser = await firebaseService.getCurrentUser();
      if (currentUser !== null) callback(currentUser);
    } else {
      onAuthStateChanged(this._auth, (user: User | null) => callback(user));
    }
  }

  async signIn(redirect_uri?: string) {
    console.log("redirect_uri", redirect_uri);
    // 1. Create credentials on the native layer
    const result = await FirebaseAuthentication.signInWithGoogle();
    console.log("[DEBUG] signin got result", result);
    // 2. Sign in on the web layer using the id token
    const credential = GoogleAuthProvider.credential(result.credential?.idToken);
    const auth = getAuth();
    const userCred = await signInWithCredential(auth, credential);
    console.log("[DEBUG] Sign in got user credential", userCred);
  }

  async signOut() {
    try {
      await FirebaseAuthentication.signOut();
    } catch (e) {
      console.error("Failed to sign out:", e);
      throw e;
    }
  }

  async getCurrentUser(): Promise<FirebaseUser | null> {
    return (await FirebaseAuthentication.getCurrentUser()).user;
  }
}

export const firebaseService = new FirebaseService();
